import React from 'react';
import { Typography } from '@mui/material';

function InputLabel({ name, label, sx = {} }) {
  return (
    <Typography
      sx={{ padding: 0, lineHeight: 1.125, ...sx }}
      variant='subtitle1'
      component='label'
      htmlFor={name}>
      {label}
    </Typography>
  );
}

export default InputLabel;
